export default "__VITE_ASSET__BzPXVYRu__"